/**
 * v0 by Vercel.
 * @see https://v0.dev/t/Nxz4y6ICj51
 * Documentation: https://v0.dev/docs#integrating-generated-code-into-your-nextjs-app
 */
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "./../../components/ui/select";
import { Card, CardContent } from "./../../components/ui/card";
import { Badge } from "./../../components/ui/badge";
import {
  Avatar,
  AvatarImage,
  AvatarFallback,
} from "./../../components/ui/avatar";
import { Button } from "./../../components/ui/button";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import TripCards from "./TripCards";

export default function NewTripCards(props) {
  const tripData = props.tripData;
  const monthName = props?.monthName?.substr(0, 3);
  // const monthName = "month_string";
  const navigate = useNavigate();
  const cardsWeb = (
    <>
      <div className="hidden md:block">
        <TripCards tripData={tripData} monthName={props?.monthName} />
      </div>
    </>
  );

  const cardsMobile = (
    <>
      <div className="md:hidden flex flex-col items-center w-full p-4 space-y-6">
        <div className="flex flex-row w-full lg:w-auto overflow-x-auto lg:grid gap-x-[4vw] lg:gap-x-[2vw] lg:grid-cols-3">
          {tripData.map((tr, tripCardIndex) => {
            return (
              <Card className="cursor-default w-full min-w-[76vw] max-w-[76vw] lg:min-w-[0] h-[min-content] lg:max-w-[24vw] overflow-hidden lg:rounded-[0.6vw] border-[2px]">
                <div className="relative">
                  <img
                    src={
                      tr?.cardImg ||
                      "https://static.wixstatic.com/media/da937f_53014b58846f4deab22e6e229df7e9a4~mv2.webp"
                    }
                    alt="Ladakh"
                    className="w-full h-[57vw] lg:h-[18vw] cursor-pointer"
                    width="300"
                    height="200"
                    style={{ aspectRatio: "300/200", objectFit: "cover" }}
                    onClick={() => {
                      if (tr.tripIdAlias) {
                        navigate(`/trip/${tr.tripIdAlias}`);
                      } else {
                        navigate(`/trip/${tr.id}`);
                      }
                    }}
                  />
                  {/* {tr?.vacancy && (
                  <Badge className={`absolute top-3 left-3 bg-red-500 text-white rounded-sm`}>
                    {tr?.vacancy}
                  </Badge>
                )} */}
                  <Badge className="absolute bottom-4 right-0 bg-red-500 text-white rounded-none">
                    {tr.tripCategory && tr.tripCategory.split(",")[0]}
                  </Badge>
                </div>
                <CardContent className="space-y-2 ml-[-3vw] lg:ml-0 pb-[0.5rem] pt-[0.3rem]">
                  {props.monthName && tr[`${monthName}`] ? (
                    <h3 className="text-md lg:text-lg font-bold mb-[-1vw]">
                      {tr[`${monthName}`]}
                    </h3>
                  ) : (
                    <h3 className="text-md lg:text-lg font-bold mb-[-1vw]">
                      {tr.tripTitleLine}
                    </h3>
                  )}

                  {/* <p className="text-sm text-muted-foreground">
                  Ladakh with Turtuk Village
                </p>
                <p className="text-sm text-muted-foreground">
                  Ladakh with Turtuk | June | 7 Days
                </p> */}
                  <p className="text-md lg:text-lg text-red-500 font-bold">
                    {tr?.tripPriceLine}
                  </p>
                  <div className="flex items-center space-x-2">
                    <Avatar>
                      <AvatarImage src={tr?.curatorImg} alt="Exploro Club" />
                      <AvatarFallback>
                        {tr?.curatorLine.split(" ")[2][0]}
                        {tr?.curatorLine.split(" ")[3] &&
                          tr?.curatorLine.split(" ")[3][0]}
                      </AvatarFallback>
                    </Avatar>
                    <p className="text-sm text-muted-foreground">
                      {tr?.curatorLine}
                    </p>
                  </div>
                </CardContent>
                <Button
                  className="w-[90%] bg-red-500 text-white ml-[5%] mb-[1rem]"
                  onClick={() => {
                    if (tr.tripIdAlias) {
                      navigate(`/trip/${tr.tripIdAlias}`);
                    } else {
                      navigate(`/trip/${tr.id}`);
                    }
                  }}
                >
                  More Details
                </Button>
              </Card>
            );
          })}
        </div>
      </div>
    </>
  );

  return (
    <>
      {cardsMobile}
      {cardsWeb}
    </>
  );
}

function PhoneIcon(props) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}
